import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import ModalContainer from 'react-modal-promise';
import { Route, Router } from 'react-router-dom';
import history from 'service/history';
import 'service/init'; // non-react related initialization
import { rootStore, RootStoreProvider } from 'store/root';
// import * as serviceWorker from './serviceWorker';
import './i18n';

const Settings = React.lazy(() => import('views/settings'));
const Promotions = React.lazy(() => import('views/promotions'));
const Main = React.lazy(() => import('views/main'));
const Login = React.lazy(() => import('views/login'));
// import "./sass/default.scss"

ReactDOM.render(
    <RootStoreProvider value={rootStore}>
        <Router history={history}>
            <Suspense fallback={<div />}>
                <Route path="/login" component={Login} />
                <Route path="/main" component={Main} />
                <Route path="/settings" component={Settings} />
                <Route path="/cross_promotion" component={Promotions} />
            </Suspense>
        </Router>
        <ModalContainer ref={rootStore.dialogs.registerRef} />
    </RootStoreProvider>,
    document.getElementById('root')
);

// serviceWorker.register();
